import * as React from 'react';
import { cn, Button } from '@ai-content-hub/content-kit';
import { BookOpen, FileText } from 'lucide-react';
import type { PresetButton } from '../types';

const ICON_MAP: Record<string, React.ElementType> = {
    BookOpen,
    FileText,
};

export interface PresetButtonsProps {
    buttons?: PresetButton[];
    activeKey: string;
    onSelect: (btn: PresetButton) => void;
    disabled?: boolean;
}

export const PresetButtons: React.FC<PresetButtonsProps> = ({
    buttons,
    activeKey,
    onSelect,
    disabled = false,
}) => {
    if (!buttons || buttons.length === 0) return null;

    return (
        <div className="prompt-description-preset-buttons flex flex-wrap gap-1.5">
            {buttons.map((btn) => {
                const Icon = btn.icon ? ICON_MAP[btn.icon] : null;
                return (
                    <Button
                        key={btn.key}
                        type="button"
                        variant={activeKey === btn.key ? 'default' : 'outline'}
                        size="sm"
                        onClick={() => onSelect(btn)}
                        disabled={disabled}
                        className={cn(
                            'prompt-description-preset-button gap-1.5 h-8 px-3 text-xs font-medium transition-all duration-200',
                            activeKey === btn.key && 'shadow-sm'
                        )}
                    >
                        {Icon && <Icon className="h-3.5 w-3.5" />}
                        {btn.label}
                    </Button>
                );
            })}
        </div>
    );
};
